export default __webpack_public_path__ + "static/media/banner.b70205ac.jpg";